
export const common = {
  // Navigation
  collections: 'المجموعات',
  about: 'من نحن',
  contact: 'اتصل بنا',
  getQuote: 'احصل على عرض سعر',
  
  // Hero Section
  heroSubtitle: 'نوفر للمنازل والمشاريع. رخام، بلاط، تشطيبات منزلية -- لدينا كل شيء.',
  exploreCollections: 'استكشف المجموعات',
  contactWhatsApp: 'تواصل معنا عبر الواتساب',
  checkLinkTree: 'صفحتنا على LinkTree',
  
  // Collections
  premiumCollections: 'مجموعاتنا المميزة',
  collectionsDescription: 'اكتشف مجموعتنا الواسعة من مواد البناء المميزة، من الرخام الطبيعي إلى البلاط السعودي المصنع محلياً',
  
  // Collection Types
  'collection.marble.title': 'الرخام المميز',
  'collection.marble.description': 'أنواع رخام رائعة من جميع أنحاء العالم',
  'collection.saudi_ceramic.title': 'السيراميك السعودي',
  'collection.saudi_ceramic.description': 'بلاط سيراميك مصنع محلياً عالي الجودة',
  'collection.saudi_porcelain.title': 'البورسلين السعودي',
  'collection.saudi_porcelain.description': 'بلاط بورسلين عالي الجودة مصنع محلياً في المملكة العربية السعودية',
  'collection.explore_more.title': 'استكشف المزيد',
  'collection.explore_more.description': 'اكتشف مجموعتنا الكاملة من مواد البناء المميزة والخدمات الشاملة',
  
  // Product Details
  size: 'الحجم',
  thickness: 'السماكة',
  origin: 'المنشأ',
  category: 'الفئة',
  finish: 'التشطيب',
  
  // Services
  professionalConsultation: 'استشارة مهنية',
  consultationDescription: 'احصل على استشارة خبراء لاحتياجاتك من مواد البناء. فريقنا المهني سيساعدك في اختيار المواد المثالية لمشروعك، وتوفير المواصفات التقنية، وتقديم خدمات تخطيط المشاريع الشاملة المصممة خصيصاً لمتطلباتك.',
  requestConsultation: 'طلب استشارة',
  productSpecifications: 'مواصفات المنتج',
  pricingInformation: 'معلومات الأسعار',
  professionalServices: 'الخدمات المهنية',
  
  // About Section
  aboutTitle: 'حول برايم ماتيريالز',
  aboutDescription: 'برايم ماتيريالز هي مورد رائد لمواد البناء المميزة في المملكة العربية السعودية، ملتزمة بالتميز ودعم رؤية السعودية 2030 من خلال التصنيع المحلي والشراكات الدولية.',
  premiumQuality: 'جودة مميزة',
  premiumQualityDesc: 'مواد مختارة بعناية من موردين عالميين موثوقين',
  localManufacturing: 'التصنيع المحلي',
  localManufacturingDesc: 'دعم رؤية السعودية 2030 بمنتجات مصنعة محلياً',
  expertService: 'خدمة خبراء',
  expertServiceDesc: 'خدمات استشارة وتركيب مهنية',
  
  // Trusted Clients - UPDATED
  trustedClients: 'فخورون بثقة أكبر الكيانات بالمملكة',
  trustedClientsDesc: '',
  
  // Contact Section - UPDATED
  contactDescription: 'مستعد لبدء مشروعك؟ تواصل معنا للحصول على استشارة خبراء وعروض أسعار',
  phone: 'الهاتف',
  email: 'البريد الإلكتروني',
  location: 'الموقع',
  
  // Menu Links
  callUs: 'اتصل بنا',
  emailUs: 'راسلنا',
  findUs: 'اعثر علينا',
  
  // Footer
  footerDescription: 'التميز في مواد البناء، صناعة مساحات استثنائية في جميع أنحاء المملكة العربية السعودية',
  services: 'الخدمات',
  contactInfo: 'معلومات الاتصال',
  naturalStones: 'الأحجار الطبيعية',
  highEndPorcelain: 'البورسلين الراقي',
  materialConsultation: 'استشارة المواد',
  projectPlanning: 'تخطيط المشاريع',
  installation: 'التركيب',
  customOrders: 'الطلبات المخصصة'
};

export default common;
